import { STATUS_LABEL, STATUS_CLS, fmtEur } from './chequesApi';
import { fmtDate } from '@/utils/dateFmt';

export default function ChequeList({ cheques, isAdmin, onOpen }) {
  if (cheques.length === 0) return <p className="text-sm text-brand-placeholder text-center py-8" data-testid="cheque-list-empty">Sem cheques para os filtros escolhidos.</p>;
  return (
    <div className="space-y-1.5" data-testid="cheque-list">
      {cheques.map(c => (
        <button key={c.id} onClick={() => onOpen(c.id)} className="w-full bg-white border border-brand-border rounded-xl p-3 flex items-center gap-3 text-left hover:border-brand-green/40 transition-colors" data-testid={`cheque-row-${c.id}`}>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-brand-text truncate">{c.patient_name} <span className="text-brand-muted font-normal">· {c.nutri_name}</span></p>
            <p className="text-[11px] text-brand-muted">{c.cheque_number || 'sem número'} · {fmtDate(c.registration_date)} · edição {c.program_edition}</p>
          </div>
          <div className="text-right shrink-0">
            <p className="text-sm font-semibold text-brand-text">{fmtEur(c.net_expected)}</p>
            {c.requires_split && <p className="text-[10px] text-brand-muted">Nutri {fmtEur(c.filipa_amount)}{isAdmin && ` · Ana ${fmtEur(c.ana_amount)}`}</p>}
          </div>
          <span className={`text-[10px] font-medium px-2 py-1 rounded-full border shrink-0 ${STATUS_CLS[c.status]}`} data-testid={`cheque-status-pill-${c.id}`}>{STATUS_LABEL[c.status]}</span>
        </button>
      ))}
    </div>
  );
}
